<template>
    <v-dialog v-model="show" @click:outside="close" width="785px">
        <div class="modal" style="height: 241px">
            <v-row>
                <div class="icon-modal table-cell" style="height: 241px">
                    <v-layout class="delete-warning-icon">
                        <v-flex>
                            <img style="position: relative;top: -43px;" :src="require('@/assets/img/warning.svg')"
                                 alt=""/>
                        </v-flex>
                    </v-layout>
                </div>
                <v-col class="table-cell modal-content declined">
                    <div class="d-flex justify-space-between">
                        <h6 class="modal-title mb-5 c-h">Add Users</h6>
                    </div>

                    <p class="c-p">Error in adding users. <br> Please review your billing information.</p>

                    <div class=" buttons d-flex">
                        <v-btn
                                class="btn-blanco c-blanco"
                                rounded
                                depressed
                                width="159"
                                @click="close"
                        >Billing Info
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>
<script>
    export default {
        props: ['show', 'hide'],
        components: {},
        methods: {
            close: function () {
                this.hide();
            }
        },
    };
</script>